import requests from './requests';

export default {
  methods: { get: requests.get, post: requests.post, patch: requests.patch, delete: requests.delete, put: requests.put },
};
